import { X } from "lucide-react";
import React, { useState } from "react";
import logo from "@assets/images/LOGO_MPS.png";
import { Link, useLocation } from "react-router-dom";
import Plainte from "./icones/plainte.tsx";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { useMenu } from "./MenuContext.tsx";
import { getUserConnectedDetail } from "@core/actions/usersActions.ts";
import Dashboard from "./icones/dashboard.tsx";
import Setting from "./icones/setting.tsx";
import ArrowRight from "./icones/arrowRight.tsx";

interface MobileHeaderProps {
  closeMobileMenu: () => void;
  isMobileMenuOpen: boolean;
}

const MenuMobile: React.FC<MobileHeaderProps> = ({
  closeMobileMenu,
  isMobileMenuOpen,
}) => {
  const dispatch = useAppDispatch();
  const detailsUserConnected = useAppSelector(userConnected);
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState<string | null>(null);
  const { setTitle } = useMenu();
  const isUserManagementActive =
    location.pathname === "/setting/add-user" ||
    location.pathname === "/setting/list-user";

  React.useEffect(() => {
    dispatch(getUserConnectedDetail());
  }, [dispatch]);

  React.useEffect(() => {
    const isComplaint = location.pathname.split("/").includes("complaint");
    if (isComplaint) {
      setTitle("Gestion des plaintes");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const normalizeText = (text: string) => text.trim().toLowerCase();

  const isDashboard = detailsUserConnected?.profil.permissions.find(
    (p: any) => normalizeText(p.name) === normalizeText("dashboard")
  );

  const isAdmin = detailsUserConnected?.profil.permissions.find(
    (p: any) => normalizeText(p.name) === normalizeText("parametre")
  );

  const isComplaint = detailsUserConnected?.profil.permissions.find(
    (p: any) => normalizeText(p.name) === normalizeText("plaintes")
  );
  return (
    <div
      className={`fixed top-0 left-0 right-0 h-96 bg-white shadow-2xl transform transition-all duration-500 ease-out z-50 rounded-b-3xl ${
        isMobileMenuOpen
          ? "translate-y-0 opacity-100"
          : "-translate-y-full opacity-0"
      }`}
    >
      <div className="p-6 h-full flex flex-col relative">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-lg p-1">
              <img src={logo} alt="Logo" className="w-32 h-auto" />
            </div>
            <div>
              <span className="text-lg font-bold text-slate-600">MPS</span>
              <p className="text-slate-400 text-xs">Menu principal</p>
            </div>
          </div>
          <button
            onClick={closeMobileMenu}
            className="p-2 rounded-full  transition-all duration-200"
          >
            <X size={24} className="text-slate-600" />
          </button>
        </div>

        {/* Navigation */}
        {/* Menu */}
        <nav className="flex flex-col mt-4">
          {isDashboard && (
            <Link
              to="/"
              className={`pl-6 menu ${
                location.pathname === "/" ? "menu-active" : ""
              }`}
              onClick={() => {
                setTitle("Tableau de bord");
                setIsMenuOpen((prev) =>
                  prev === "dashbord" ? null : "dashbord"
                );
                closeMobileMenu();
              }}
            >
              <span className="pr-2">
                <Dashboard
                  color={location.pathname === "/" ? "#086D33" : "#6C757D"}
                />
              </span>
              Tableau de bord
            </Link>
          )}
          {isAdmin && (
            <div
              className={`pl-6 pr-3 menu ${
                isMenuOpen === "setting" ? "menu-active" : ""
              } flex justify-between items-center`}
              onClick={() => {
                setIsMenuOpen((prev) =>
                  prev === "setting" ? null : "setting"
                );
                // navigate("/setting/data");
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="flex items-center">
                <span className="pr-2">
                  <Setting
                    color={isMenuOpen === "setting" ? "#086D33" : "#6C757D"}
                  />
                </span>
                Paramètres
              </div>
              {/* Flèche */}
              <span
                className={`transition-transform ${
                  isMenuOpen ? "rotate-90" : "rotate-0"
                }`}
              >
                <ArrowRight
                  color={isMenuOpen === "setting" ? "#086D33" : "#6C757D"}
                />
              </span>
            </div>
          )}

          {isMenuOpen === "setting" && (
            <div>
              <Link
                to="/setting/data"
                className={`pl-[3.8rem] block menu ${
                  location.pathname === "/setting/data" ? "submenu-active" : ""
                }`}
                onClick={() => {
                  setTitle("Gestion des données");
                  closeMobileMenu();
                }}
              >
                Gestion des données
              </Link>
              <Link
                to="/setting/list-user"
                className={`pl-[3.8rem] block menu ${
                  isUserManagementActive ? "submenu-active" : ""
                }`}
                onClick={() => {
                  setTitle("Gestion des utilisateurs");
                  closeMobileMenu();
                }}
              >
                Gestion des utilisateurs
              </Link>
              <Link
                to="/setting/group"
                className={`pl-[3.8rem] block menu ${
                  location.pathname === "/setting/group" ? "submenu-active" : ""
                }`}
                onClick={() => {
                  setTitle("Gestion des groupes");
                  closeMobileMenu();
                }}
              >
                Gestion des groupes
              </Link>
            </div>
          )}

          {isComplaint && (
            <Link
              to="/complaint/list-complaint"
              className={`pl-6 menu ${
                location.pathname === "/complaint/list-complaint"
                  ? "menu-active"
                  : ""
              }`}
              onClick={() => {
                setTitle("Gestion des plaintes");
                setIsMenuOpen((prev) =>
                  prev === "complaint" ? null : "complaint"
                );
                closeMobileMenu();
              }}
            >
              <span className="pr-2">
                <Plainte
                  color={
                    location.pathname === "/complaint/list-complaint"
                      ? "#086D33"
                      : "#6C757D"
                  }
                />
              </span>
              Plaintes
            </Link>
          )}
        </nav>
        <div className="w-12 h-1 bg-slate-600 rounded-full mx-auto absolute bottom-5 left-1/2"></div>
      </div>
    </div>
  );
};
export default MenuMobile;
